exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-carousel-indicators li, .custom-carousel-indicators li.active {\n  width: 50px;\n  height: 8px;\n  margin: 0 3px;\n  border-radius: 0;\n}\n", ""]);

// exports
